<script>
    import R, {LOADER} from "../lib/requests";
    import {pad0, formatDate, getDate} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import CalendarNavigation from "../calendar/CalendarNavigation.svelte";
    import Alert from "../stores/alerts";
    import {WEEKDAYS, MONTHS} from "../lib/constants";
    import Notifier from "../stores/notifier";


    let calendar = [];
    let calendarDate = null;
    let calendarMonth = 0;
    let calendarYear = 0;
    let today = getDate();
    let stopSales = null;
    let addDates = [];
    let removeDates = [];
    let reason = '';

    const pageHeaderControls = [
        {id: 'save', name: 'SAVE'},
    ];

    const getDaysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };

    const stepMonth = (year, month, step) => {
        let m = month + step;
        let y = year;
        if (m > 12) {
            m = 1;
            y++;
        } else if (m < 1) {
            m = 12;
            y--;
        }

        return [y, m];
    }

    const setCalendar = () => {
        let monthDays = 0;
        let prevMonthDays = 0;
        calendar = [];

        monthDays = getDaysInMonth(calendarMonth, calendarYear);
        prevMonthDays = getDaysInMonth(calendarMonth - 1, calendarYear);
        let [previousYear, previousMonth] = stepMonth(calendarYear, calendarMonth, -1);
        let [nextYear, nextMonth] = stepMonth(calendarYear, calendarMonth, 1);

        let d = 0;
        let firstWeekDay = new Date(`${calendarYear}-${pad0(calendarMonth)}-01`).getDay() - 1; // 6 - Saturday
        if (firstWeekDay < 0) {
            firstWeekDay = 6;
        }
        // previous month
        d = prevMonthDays - firstWeekDay + 1;
        for (let index = 0; index < firstWeekDay; index++) {
            calendar.push({
                day: d,
                active: false,
                date: `${previousYear}-${pad0(previousMonth)}-${pad0(d)}`
            });
            d++;
        }
        // current month
        for (d = 1; d <= monthDays; d++) {
            calendar.push({
                day: d,
                active: true,
                date: `${calendarYear}-${pad0(calendarMonth)}-${pad0(d)}`
            });
        }
        // next month
        if (calendar.length % 7 > 0) {
            let daysToAdd = 7 - (calendar.length % 7);
            for (let d = 1; d <= daysToAdd; d++) {
                calendar.push({
                    day: d,
                    active: false,
                    date: `${nextYear}-${pad0(nextMonth)}-${pad0(d)}`
                });
            }
        }

        stopSales.map(date => {
            let cd = calendar.find(x => x.date === date);
            if (cd) {
                cd.stop_sales = true;
            }
        });

        calendar = calendar;
    }

    const initialize = () => {
        let dt;
        dt = new Date();

        calendarMonth = dt.getMonth() + 1;
        calendarYear = dt.getFullYear();

        load();
    }

    const previousMonth = () => {
        calendarMonth--;
        if (calendarMonth < 1) {
            calendarYear--;
            calendarMonth = 12;
        }
        setCalendar();
    }

    const nextMonth = () => {
        calendarMonth++;
        if (calendarMonth > 12) {
            calendarYear++;
            calendarMonth = 1;
        }
        setCalendar();
    }

    const toggleDate = (day) => {
        if (day.stop_sales) {
            if (removeDates.indexOf(day.date) > -1) {
                removeDates = removeDates.filter(x => x != day.date);
            } else {
                removeDates.push(day.date);
            }
            removeDates = removeDates;
        } else {
            if (addDates.indexOf(day.date) > -1) {
                addDates = addDates.filter(x => x != day.date);
            } else {
                addDates.push(day.date);
            }
            addDates = addDates;
        }
        calendar = calendar;
    }

    const load = () => {
        const onSuccess = result => {
            stopSales = result;
            setCalendar();
        }

        const onFailure = err => {
            let message = err.message ? err.message : "There was an error occurred while loading data.";
            Alert.warning("Stop sales", message);
        };

        R.handle(R.stopSale.index, [], onSuccess, onFailure, LOADER.PAGE);
    }


    const save = () => {

        const onSuccess = result => {
            addDates = [];
            removeDates = [];
            reason = '';
            Notifier.showMessage("Dates updated");
            load();
        }

        const onFailure = err => {
        }

        const data = {
            add_dates: addDates,
            reason,
            remove_dates: removeDates
        };

        if (addDates.length == 0 && removeDates.length == 0) {
            Notifier.showError("Select dates to add or remove");
            return;
        }

        R.handle(R.stopSale.save, data, onSuccess, onFailure, LOADER.PAGE);
    }

    const clearSelected = () => {
        addDates = [];
        removeDates = [];
    }


    initialize();

    $: {
        today = getDate();
    }
</script>

<PageHeader title="Stop Sales" controls={ pageHeaderControls } on:save={ save }/>
<div class="row">
    <div class="col-md-8">
        <CalendarNavigation title="{ MONTHS[calendarMonth - 1] } { calendarYear }"
                            on:click_previous="{ previousMonth }"
                            on:click_next="{ nextMonth }"/>

        <div class="calendar mb-4">
            {#each WEEKDAYS as wDay}
                <div class="weekday">
                    { wDay }
                </div>
            {/each}
            {#each calendar as day}
                <button class="day" class:active={ day.active } class:selected="{ day.date === calendarDate }"
                        class:today={ day.date === today }
                        class:stop-sales={day.stop_sales}
                        class:remove-date={day.action === 'remove'}
                        on:click="{ () => toggleDate(day) }">

                    { day.day }
                    {#if addDates.indexOf(day.date) > -1}
                        <span class="stop-icon"><AppIcon icon="calendar-add" size="18"/></span>
                    {:else if removeDates.indexOf(day.date) > -1}
                        <span class="stop-icon"><AppIcon icon="calendar-xmark" size="18"/></span>
                    {/if}
                </button>
            {/each}
        </div>
    </div>
    <div class="col-md-4">
        {#if addDates.length > 0 || removeDates.length > 0}
            <div class="panel panel-default mb-3">
                {#if addDates.length > 0}
                    <div class="panel-heading">
                        Add dates in stop sales
                    </div>
                    <div class="panel-body panel-pad">
                        <div class="date-list mb-2">
                            {#each addDates as date}
                                <div class="date-item">{formatDate(date, 'd-m-y')}</div>
                            {/each}
                        </div>
                        <div>
                            <label>Reason</label>
                            <textarea class="form-control" bind:value="{ reason }"></textarea>
                        </div>
                    </div>
                {/if}
                {#if removeDates.length > 0}
                    <div class="panel-heading">
                        Remove dates from stop sales
                    </div>
                    <div class="panel-body panel-pad">
                        <div class="date-list">
                            {#each removeDates as date}
                                <div class="date-item">{formatDate(date, 'd-m-y')}</div>
                            {/each}
                        </div>
                    </div>
                {/if}
            </div>
            <div class="text-end">
                <button class="btn btn-default me-2" on:click={clearSelected}>CLEAR SELECTED</button>
                <button class="btn btn-primary px-5" on:click={save}>SAVE</button>
            </div>
        {:else}
            <div class="panel-simple panel-pad">
                Select dates from calendar to add or remove from stop sales.
            </div>
        {/if}

    </div>
</div>


<style>
    .calendar {
        color: #ababab;
        background: #fff;
        border: var(--default-border);
        border-radius: 3px;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        text-align: center;
        grid-gap: 1px;
        background: var(--default-border-color);
    }

    .calendar .weekday {
        letter-spacing: 1px;
        line-height: 1;
        color: #803384;
        background: #e4eaee;
        padding: 15px 0;
    }

    .calendar .day {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
        font-size: 1.05rem;
        font-weight: 500;
        background: #f8fafb;
        border: unset;
        outline: none;
    }

    .calendar .day:hover {
        background: #eeeeee;
    }

    .calendar .day.active {
        color: #333333;
        background: #fff;
    }

    .calendar .day.today {
        background: #fff1c6;
    }

    .calendar .day.selected {
        background: #e4eaee;
    }


    .calendar .day.stop-sales {
        color: #fff;
        background: rgba(500, 0, 0, 0.5);
    }

    .calendar .day .stop-icon {
        position: absolute;
        top: 8px;
        right: 8px;
        color: rgba(500, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .calendar .day.stop-sales .stop-icon {
        color: #fff;
    }


    .date-list {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }

    .date-item {
        background: rgb(242 246 248);
        padding: 2px 5px;
        border-radius: 2px;
    }

    @media (max-width: 576px) {
        .calendar .weekday {
            letter-spacing: unset;
        }

        .calendar .day {
            justify-content: flex-start;
            height: 60px;
            font-size: 1rem;
            font-weight: normal;
            padding: 0 0 0 8px;
        }

        .calendar .day .stop-icon {
            top: 4px;
            right: 2px;
        }
    }
</style>